<div class="modal client-modal" data-cy="client-modal">
  <header class="modal__header">
    <h2 class="modal__header__title" data-cy="modal-title">
      <span translate>New client</span>
    </h2>
    <button class="modal__header__close" (click)="close()">
      <i class="icon icon-close_ico"></i>
    </button>
  </header>

  <div class="modal__content create-container">
    <form class="create-container__form" [formGroup]="formGroup">
      <div class="control-container form-group py-0" appFormControlError="name">
        <div class="control-container__label">
          <span translate>Name</span>
          <span class="control-container__required">*</span>
        </div>

        <input
          #clientNameInput
          class="control-container__control"
          type="text"
          formControlName="name"
          data-cy="client-name-input" />
      </div>

      <div class="controls-row">
        <div class="control-container form-group py-0" appFormControlError="contact_person">
          <div class="control-container__label">
            <span translate>Contact person</span>
          </div>

          <input class="control-container__control" type="text" data-cy="contact-person-input" formControlName="contact_person" />
        </div>

        <div class="control-container form-group py-0" appFormControlError="email">
          <div class="control-container__label">
            <span translate>Email</span>
          </div>

          <input class="control-container__control" type="text" data-cy="client-email-input" formControlName="email" />
        </div>
      </div>

      <div class="controls-row controls-row__last">
        <div class="control-container form-group py-0" appFormControlError="phone">
          <div class="control-container__label">
            <span translate>Phone</span>
          </div>

          <input class="control-container__control" type="text" data-cy="client-phone-input" formControlName="phone" />
        </div>

        <div class="control-container form-group py-0" appFormControlError="display_id">
          <div class="control-container__label">
            <span translate>ID</span>
          </div>
          <loader [loading]="getAvailableNumberRequest.loading$" [small]="true"></loader>

          <input
            class="control-container__control"
            type="text"
            [disabled]="getAvailableNumberRequest.loading$ | push"
            data-cy="client-display-id-input"
            formControlName="display_id" />
        </div>
      </div>

      <div class="create-container__billing-part" formGroupName="billing_address">
        <div class="create-container__billing-title">
          <span translate>Billing Address</span>

          <span
            data-cy="Copy to shipping address"
            class="icon copy-icon copy-billing-icon icon-Arrow_ico"
            (click)="copyAddress(addressEnum.Billing)"
            matTooltip="{{ 'Copy to shipping address' | translate }}">
          </span>
        </div>

        <div class="control-container">
          <div class="control-container__label">
            <span translate>Street</span>
          </div>

          <input class="control-container__control" type="text" data-cy="billing-street-input" formControlName="street" />
        </div>

        <div class="controls-row">
          <div class="control-container">
            <div class="control-container__label">
              <span translate>City</span>
            </div>

            <input class="control-container__control" type="text" data-cy="billing-city-input" formControlName="city" />
          </div>

          <div class="control-container form-group py-0" appFormControlError="state">
            <div class="control-container__label">
              <span translate>State</span>
            </div>

            <input class="control-container__control" type="text" data-cy="billing-state-input" formControlName="state" />
          </div>
        </div>

        <div class="controls-row controls-row__last">
          <div class="control-container form-group py-0" appFormControlError="zip">
            <div class="control-container__label">
              <span translate>Zip Code</span>
            </div>

            <input class="control-container__control" type="text" data-cy="billing-zip-input" formControlName="zip" />
          </div>

          <div class="control-container">
            <div class="control-container__label">
              <span translate>Country</span>
            </div>

            <app-select
              valueKey="id"
              displayKey="name"
              data-cy="billing-country-select"
              [hasBackdrop]="true"
              [placeholder]="'Select Country...' | translate"
              [formControlName]="formKeys.country_id"
              [model]="billingCountryModel"
              [collection]="countriesCollection"
              [optionList]="countriesCollection.items$ | push"
              (refreshCallback)="getCountriesList($event)"
              (selectedValue)="formGroup.markAsDirty(); updateCountryModel(addressEnum.Billing, $event)">
            </app-select>
          </div>
        </div>
      </div>

      <div class="create-container__billing-part" formGroupName="shipping_address">
        <div class="create-container__billing-title">
          <span translate>Shipping Address</span>
          <span
            data-cy="Copy to billing address"
            class="icon copy-icon icon-Arrow_ico"
            (click)="copyAddress(addressEnum.Shipping)"
            matTooltip="{{ 'Copy to billing address' | translate }}">
          </span>
        </div>

        <div class="control-container">
          <div class="control-container__label">
            <span translate>Street</span>
          </div>

          <input class="control-container__control" type="text" data-cy="shipping-street-input" formControlName="street" />
        </div>

        <div class="controls-row">
          <div class="control-container">
            <div class="control-container__label">
              <span translate>City</span>
            </div>

            <input class="control-container__control" type="text" data-cy="shipping-city-input" formControlName="city" />
          </div>

          <div class="control-container form-group py-0" appFormControlError="state">
            <div class="control-container__label">
              <span translate>State</span>
            </div>

            <input class="control-container__control" type="text" data-cy="shipping-state-input" formControlName="state" />
          </div>
        </div>

        <div class="controls-row controls-row__last">
          <div class="control-container form-group py-0" appFormControlError="zip">
            <div class="control-container__label">
              <span translate>Zip Code</span>
            </div>

            <input class="control-container__control" type="text" data-cy="shipping-zip-input" formControlName="zip" />
          </div>

          <div class="control-container">
            <div class="control-container__label">
              <span translate>Country</span>
            </div>

            <app-select
              valueKey="id"
              displayKey="name"
              data-cy="shipping-country-select"
              [hasBackdrop]="true"
              [placeholder]="'Select Country...' | translate"
              [formControlName]="formKeys.country_id"
              [model]="shippingCountryModel"
              [collection]="countriesCollection"
              [optionList]="countriesCollection.items$ | push"
              (refreshCallback)="getCountriesList($event)"
              (selectedValue)="formGroup.markAsDirty(); updateCountryModel(addressEnum.Shipping, $event)">
            </app-select>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal__actions mt-3">
    <div class="btn-group row-flex row-flex--middle mx-0">
      <button class="btn btn__bordered mr-2 uppercase" (click)="close()" data-cy="cancel-button">
        <span translate>Cancel</span>
      </button>

      <btn-loader
        styleClasses="btn__primary"
        [uppercase]="true"
        [buttonLabel]="'Create Client' | translate"
        [loading]="(clientItem.loadingCrud$ | async).creating"
        (applyAction)="submit()"
        data-cy="Client Save Button"></btn-loader>
    </div>
  </div>
</div>
